export default function mmToInches(mm) {
    return (mm / 25.4).toFixed(2); // Convert mm to inches and round to two decimal places
  }
  